// MesAbeilles - gestion des formulaires produit, offres volume et popup produit.
// V2.11 : la fenêtre « Choisir mon offre » accepte des réglages par carte
// (data-popup-facts, data-popup-info, data-popup-word, data-popup-qty-label, data-popup-delivery)
// et data-popup-weight-kg (poids total pour le prix au kilo)
// pour le Colis de 6, la gelée royale et la cuillère.

(() => {
  if (window.maCommerce) return;
  window.maCommerce = true;

  const shopRoot = () =>
    (window.Shopify?.routes?.root || "/").replace(/\/?$/, "/");

  function getImageUrl(source) {
    if (!source) return "";
    let url = "";
    if (typeof source === "string") {
      url = source;
    } else if (source.src) {
      url = source.src;
    } else if (source.url) {
      url = source.url;
    }
    if (!url) return "";
    return url.startsWith("//") ? "https:" + url : url;
  }

  function plural(word, quantity) {
    if (quantity <= 1) return word;
    return /[sx]$/.test(word) ? word : word + "s";
  }

  function initProductForms(scope = document) {
    scope.querySelectorAll("[data-ma-product-form]").forEach(form => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = "true";

      const select = form.querySelector("[data-ma-variant]");
      const offers = form.querySelector("[data-ma-offers]");
      const button = form.querySelector("[data-ma-add]");
      const status = form.querySelector("[data-ma-status]");
      const formatButtons = form.querySelectorAll("[data-ma-product-format-button]");

      if (!select || !button) return;

      let busy = false;

      const money = cents =>
        (Number(cents || 0) / 100).toLocaleString(
          document.documentElement.lang || "fr-FR",
          { style: "currency", currency: offers?.dataset.currency || "EUR" }
        );

      function syncProductFormatButtons() {
        formatButtons.forEach(formatButton => {
          const selected = String(formatButton.dataset.variantId) === String(select.value);
          formatButton.classList.toggle("is-selected", selected);
          formatButton.setAttribute("aria-pressed", selected ? "true" : "false");
        });
      }

      function getWeightInKg(title) {
        const normalized = String(title || "").toLowerCase().replace(",", ".");
        let match = normalized.match(/(\d+(?:\.\d+)?)\s*kg\b/);
        if (match) return Number(match[1]);
        match = normalized.match(/(\d+(?:\.\d+)?)\s*g\b/);
        if (match) return Number(match[1]) / 1000;
        return null;
      }

      function getQuantity() {
        return Number(
          form.querySelector('[name="quantity"]:checked')?.value ||
          form.querySelector('[name="quantity"]')?.value ||
          1
        );
      }

      function getRate(quantity) {
        if (!offers) return 0;
        if (quantity === 5) return Number(offers.dataset.five || 0);
        if (quantity === 3) return Number(offers.dataset.three || 0);
        return 0;
      }

      function update() {
        const option = select.selectedOptions[0];
        if (!option) {
          button.disabled = true;
          return;
        }

        const available = option.dataset.available === "true";
        button.disabled = busy || !available;

        const price = form.querySelector("[data-ma-price]");
        const unitPrice = form.querySelector("[data-ma-unit-price]");
        const base = Number(option.dataset.cents || 0);
        const quantity = getQuantity();
        const selectedRate = getRate(quantity);
        const selectedUnitPrice = Math.round(base * (100 - selectedRate) / 100);

        if (price) {
          price.textContent = offers
            ? money(selectedUnitPrice * quantity)
            : (option.dataset.price || money(base));
        }

        if (unitPrice) {
          const weightKg = getWeightInKg(option.dataset.title);
          const kilo = weightKg && weightKg > 0
            ? `${money(Math.round(selectedUnitPrice / weightKg))}/kg`
            : "";
          unitPrice.textContent = offers && quantity > 1
            ? `soit ${money(selectedUnitPrice)} le pot${kilo ? " · " + kilo : ""}`
            : (kilo || option.dataset.unitReference || "");
        }

        syncProductFormatButtons();

        if (offers) {
          const variantTitle = option.dataset.title === "Default Title" ? "" : ` (${option.dataset.title})`;
          let saving = 0;

          offers.querySelectorAll(".offer-option").forEach(row => {
            const input = row.querySelector('input[type="radio"][name="quantity"]');
            if (!input) return;

            const q = Number(input.value);
            const rate = getRate(q);
            const discountedUnit = Math.round(base * (100 - rate) / 100);
            const normalTotal = base * q;
            const discountedTotal = discountedUnit * q;

            const label = row.querySelector("[data-ma-label]");
            const total = row.querySelector("[data-ma-total]");
            const before = row.querySelector("[data-ma-before]");
            const rateElement = row.querySelector("[data-ma-rate]");
            const economy = row.querySelector("[data-ma-economy]");
            const unit = row.querySelector("[data-ma-unit]");

            if (label) label.textContent = `${q} × POT${q > 1 ? "S" : ""}${variantTitle}`;
            if (total) total.textContent = money(discountedTotal);
            if (before) before.textContent = rate ? money(normalTotal) : "";
            if (rateElement) rateElement.textContent = rate ? `−${rate} %` : "";
            if (economy) {
              economy.textContent = rate
                ? `Vous économisez ${money(normalTotal - discountedTotal)}`
                : q === 1 ? "À l’unité" : "Pour faire votre réserve";
            }
            if (unit) unit.textContent = `${money(discountedUnit)} / pot`;
            if (q === quantity) saving = normalTotal - discountedTotal;
          });

          const savingElement = form.querySelector("[data-ma-saving]");
          if (savingElement) {
            savingElement.textContent = saving ? `Vous économisez ${money(saving)}` : "";
          }
        }

        button.textContent = busy
          ? "Ajout en cours…"
          : available
            ? offers
              ? `Ajouter ${quantity} pot${quantity > 1 ? "s" : ""} au panier`
              : "Ajouter au panier"
            : "Épuisé";
      }

      formatButtons.forEach(formatButton => {
        formatButton.addEventListener("click", () => {
          if (formatButton.disabled) return;
          const variantId = formatButton.dataset.variantId;
          if (!variantId) return;
          if (String(select.value) === String(variantId)) {
            syncProductFormatButtons();
            return;
          }
          select.value = String(variantId);
          select.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });

      if (offers) {
        const quantityThree = form.querySelector('input[type="radio"][name="quantity"][value="3"]');
        if (quantityThree) quantityThree.checked = true;
      }

      form.addEventListener("change", event => {
        if (status) status.textContent = "";
        update();

        if (event.target === select && select.hasAttribute("data-update-url")) {
          const url = new URL(window.location.href);
          url.searchParams.set("variant", select.value);
          window.history.replaceState({}, "", url);

          const image = form.closest(".detail-layout")?.querySelector("[data-main-product-image]");
          const source = select.selectedOptions[0]?.dataset.image;
          if (image && source) {
            image.removeAttribute("srcset");
            image.src = source;
          }
        }
      });

      form.addEventListener("submit", async event => {
        event.preventDefault();
        if (!window.fetch || busy || button.disabled || !form.reportValidity()) return;

        const body = new FormData(form);
        busy = true;
        if (status) status.textContent = "";
        update();

        try {
          const response = await fetch(shopRoot() + "cart/add.js", {
            method: "POST",
            headers: { Accept: "application/json" },
            body
          });
          const data = await response.json();
          if (!response.ok) {
            throw new Error(data.description || data.message || "Ce produit ne peut pas être ajouté pour le moment.");
          }
          window.location.assign(form.dataset.cartUrl || shopRoot() + "cart");
        } catch (error) {
          if (status) {
            status.textContent = error.message === "Failed to fetch"
              ? "Connexion interrompue. Consultez votre panier avant de réessayer."
              : error.message;
          }
          busy = false;
          update();
        }
      });

      update();
    });
  }

  function initOfferPopup() {
    const dialog = document.querySelector("[data-ma-offer-dialog]");
    if (!dialog || dialog.dataset.initialized) return;
    dialog.dataset.initialized = "true";

    const title = dialog.querySelector("[data-ma-popup-title]");
    const description = dialog.querySelector("[data-ma-popup-description]");
    const image = dialog.querySelector("[data-ma-popup-image]");
    const form = dialog.querySelector("[data-ma-popup-form]");
    const variantSelect = dialog.querySelector("[data-ma-popup-variant]");
    const formatButtons = dialog.querySelector("[data-ma-popup-format-buttons]");
    const addButton = dialog.querySelector("[data-ma-popup-add]");
    const status = dialog.querySelector("[data-ma-popup-status]");
    const closeButton = dialog.querySelector("[data-ma-close-offer]");
    const grandTotal = dialog.querySelector("[data-ma-popup-grand-total]");
    const globalSaving = dialog.querySelector("[data-ma-popup-global-saving]");
    const kiloElement = dialog.querySelector("[data-ma-popup-kilo]");
    const eyebrow = dialog.querySelector("[data-ma-popup-eyebrow]");
    const factOne = dialog.querySelector("[data-ma-popup-fact-one]");
    const factTwo = dialog.querySelector("[data-ma-popup-fact-two]");
    const factThree = dialog.querySelector("[data-ma-popup-fact-three]");
    const taste = dialog.querySelector("[data-ma-popup-taste]");
    const pairing = dialog.querySelector("[data-ma-popup-pairing]");
    const delivery = dialog.querySelector(".ma-popup-delivery");
    const defaultDelivery = delivery ? delivery.textContent : "";

    if (!form || !variantSelect || !addButton) return;

    const rateThree = Number(dialog.dataset.rateThree || 5);
    const rateFive = Number(dialog.dataset.rateFive || 10);
    const currency = dialog.dataset.currency || "EUR";

    const money = cents =>
      (Number(cents || 0) / 100).toLocaleString(
        document.documentElement.lang || "fr-FR",
        { style: "currency", currency }
      );

    let currentProduct = null;
    let busy = false;
    let cardImageUrl = "";
    let currentKind = "";
    let currentVolumeEligible = false;
    let currentWord = "";
    let currentQtyLabel = "";
    let currentWeightKg = 0;

    const offersFieldset = form.querySelector("[data-ma-popup-offers]");
    const variantLabel = form.querySelector('.ma-popup-format-label, label[for="ma-popup-variant"]');
    const formatHelp = kiloElement?.closest(".format-help");
    const formatHelpTextNodes = Array.from(formatHelp?.childNodes || [])
      .filter(node => node.nodeType === 3)
      .map(node => ({ node, text: node.textContent }));

    const coffretPrice = document.createElement("p");
    coffretPrice.className = "price";
    coffretPrice.setAttribute("data-ma-coffret-price", "");
    form.insertBefore(coffretPrice, form.firstChild);

    const simpleQuantityGroup = document.createElement("div");
    simpleQuantityGroup.className = "ma-coffret-quantity";
    simpleQuantityGroup.style.margin = "18px 0";

    const simpleQuantityLabel = document.createElement("label");
    simpleQuantityLabel.className = "format-label";
    simpleQuantityLabel.htmlFor = "ma-popup-simple-quantity";

    const simpleQuantityInput = document.createElement("input");
    simpleQuantityInput.id = "ma-popup-simple-quantity";
    simpleQuantityInput.className = "ma-quantity-input";
    simpleQuantityInput.type = "number";
    simpleQuantityInput.name = "quantity";
    simpleQuantityInput.min = "1";
    simpleQuantityInput.step = "1";
    simpleQuantityInput.value = "1";
    simpleQuantityInput.required = true;
    simpleQuantityInput.disabled = true;
    simpleQuantityInput.style.cssText =
      "display:block;width:110px;min-height:48px;margin-top:8px;padding:10px 12px;border:1px solid #c9c6bc;border-radius:4px;font:inherit;background:#fff;color:inherit;";

    simpleQuantityGroup.append(simpleQuantityLabel, simpleQuantityInput);
    form.insertBefore(simpleQuantityGroup, offersFieldset || addButton);

    function setHidden(element, hidden) {
      if (!element) return;
      element.hidden = hidden;
      if (hidden) {
        element.style.setProperty("display", "none", "important");
      } else {
        element.style.removeProperty("display");
      }
    }

    setHidden(coffretPrice, true);
    setHidden(simpleQuantityGroup, true);

    simpleQuantityInput.addEventListener("input", () => {
      if (status) status.textContent = "";
      updatePopup();
    });

    function isCoffret() {
      return (
        currentKind === "coffret" ||
        currentProduct?.handle === "coffret-decouverte-3-miels-de-normandie-3-250-g"
      );
    }

    function isVolumeEligible() {
      return currentVolumeEligible === true;
    }

    function getVariant() {
      if (!currentProduct) return null;
      return currentProduct.variants.find(variant => String(variant.id) === String(variantSelect.value));
    }

    function getQuantity() {
      if (!isVolumeEligible()) {
        return Math.max(1, Math.floor(Number(simpleQuantityInput.value) || 1));
      }
      return Number(form.querySelector('[name="quantity"]:checked')?.value || 1);
    }

    function getRate(quantity) {
      if (!isVolumeEligible()) return 0;
      if (quantity === 3) return rateThree;
      if (quantity === 5) return rateFive;
      return 0;
    }

    function setPopupImage(source) {
      if (!image) return false;
      const url = getImageUrl(source);
      if (!url) return false;
      image.style.display = "block";
      image.removeAttribute("srcset");
      image.src = url;
      if (currentProduct?.title) image.alt = currentProduct.title;
      return true;
    }

    function getFormatLabel(variant) {
      if (!variant || !variant.title || variant.title === "Default Title") return "";
      return variant.title.replace(/\s+/g, " ").trim().toUpperCase();
    }

    function getDisplayFormatLabel(variant) {
      if (!variant || !variant.title || variant.title === "Default Title") return "À l’unité";
      return variant.title.replace(/\s+/g, " ").trim();
    }

    function syncFormatButtons() {
      if (!formatButtons) return;
      formatButtons.querySelectorAll("[data-ma-popup-format-button]").forEach(button => {
        const selected = String(button.dataset.variantId) === String(variantSelect.value);
        button.classList.toggle("is-selected", selected);
        button.setAttribute("aria-pressed", selected ? "true" : "false");
      });
    }

    function renderFormatButtons() {
      if (!formatButtons || !currentProduct) return;
      formatButtons.innerHTML = "";
      const variants = currentProduct.variants || [];

      if (variants.length <= 1) {
        setHidden(formatButtons, true);
        setHidden(variantSelect, false);
        return;
      }

      variants.forEach(variant => {
        const button = document.createElement("button");
        button.type = "button";
        button.className = "ma-popup-format-button";
        button.setAttribute("data-ma-popup-format-button", "");
        button.dataset.variantId = String(variant.id);
        button.disabled = !variant.available;

        const label = document.createElement("strong");
        label.className = "ma-popup-format-button-label";
        label.textContent = getDisplayFormatLabel(variant);

        const price = document.createElement("span");
        price.className = "ma-popup-format-button-price";
        price.textContent = money(variant.price);

        button.append(label, price);
        button.addEventListener("click", () => {
          if (!variant.available) return;
          variantSelect.value = String(variant.id);
          variantSelect.dispatchEvent(new Event("change", { bubbles: true }));
        });

        formatButtons.appendChild(button);
      });

      setHidden(formatButtons, false);
      setHidden(variantSelect, true);
      syncFormatButtons();
    }

    function getWeightInKg(variant) {
      if (!variant) return null;

      // Poids total fourni par la carte (ex. Colis de 6 = 3 kg).
      if (currentWeightKg > 0) return currentWeightKg;

      if (
        currentProduct?.handle === "coffret-decouverte-3-miels-de-normandie-3-250-g" &&
        currentProduct.variants.length === 1
      ) {
        return 0.75;
      }

      function parseWeight(text) {
        const normalized = String(text || "").toLowerCase().replace(",", ".");
        let match = normalized.match(/(\d+(?:\.\d+)?)\s*kg\b/);
        if (match) return Number(match[1]);
        match = normalized.match(/(\d+(?:\.\d+)?)\s*g\b/);
        if (match) return Number(match[1]) / 1000;
        return null;
      }

      return parseWeight(variant.title) || parseWeight(currentProduct?.title);
    }

    function updatePopup() {
      const variant = getVariant();
      if (!variant) return;

      const coffret = isCoffret();
      const volumeEligible = isVolumeEligible();
      const singleFormat = currentProduct.variants.length === 1;

      setHidden(offersFieldset, !volumeEligible);
      if (offersFieldset) offersFieldset.disabled = !volumeEligible;

      setHidden(simpleQuantityGroup, volumeEligible);
      simpleQuantityInput.disabled = volumeEligible;
      simpleQuantityInput.readOnly = busy;

      simpleQuantityLabel.textContent =
        currentQtyLabel ||
        (coffret
          ? "Nombre de coffrets"
          : currentKind === "bonbons"
            ? "Nombre de sachets"
            : "Nombre de pots");

      if (variantLabel) {
        const firstOption = currentProduct.options?.[0];
        const optionName = typeof firstOption === "string" ? firstOption : firstOption?.name;
        variantLabel.textContent = optionName === "Parfum"
          ? "Choisissez votre parfum"
          : "1. Choisissez votre format";
      }

      setHidden(coffretPrice, !(coffret || singleFormat));
      coffretPrice.textContent = money(variant.price);

      setHidden(variantLabel, singleFormat);

      if (formatButtons && currentProduct.variants.length > 1) {
        setHidden(variantSelect, true);
        setHidden(formatButtons, false);
        syncFormatButtons();
      } else {
        setHidden(variantSelect, singleFormat);
        setHidden(formatButtons, true);
      }

      dialog.querySelectorAll(".offer-badge").forEach(badge => setHidden(badge, !volumeEligible));
      setHidden(form.querySelector(".note"), !volumeEligible);

      const tasting = dialog.querySelector("[data-ma-popup-tasting]");
      if (tasting) {
        const tasteEmpty = !(taste?.textContent || "").trim();
        const pairingEmpty = !(pairing?.textContent || "").trim();
        setHidden(taste?.closest(".ma-popup-tasting-row, .tasting-row"), tasteEmpty);
        setHidden(pairing?.closest(".ma-popup-tasting-row, .tasting-row"), pairingEmpty);
        setHidden(tasting, tasteEmpty && pairingEmpty);
      }

      formatHelpTextNodes.forEach(entry => {
        entry.node.textContent = coffret ? "" : entry.text;
      });

      const basePrice = Number(variant.price || 0);
      const selectedQuantity = getQuantity();
      const selectedRate = getRate(selectedQuantity);
      const selectedUnitPrice = Math.round(basePrice * (100 - selectedRate) / 100);
      const formatLabel = getFormatLabel(variant);

      dialog.querySelectorAll(".offer-option").forEach(row => {
        const input = row.querySelector('input[name="quantity"]');
        if (!input) return;

        const quantity = Number(input.value);
        const rate = getRate(quantity);
        const unitPrice = Math.round(basePrice * (100 - rate) / 100);
        const normalTotal = basePrice * quantity;
        const discountedTotal = unitPrice * quantity;

        const labelElement = row.querySelector("[data-ma-popup-label]");
        const totalElement = row.querySelector("[data-ma-popup-total]");
        const savingElement = row.querySelector("[data-ma-popup-saving]");
        const beforeElement = row.querySelector("[data-ma-popup-before]");
        const unitElement = row.querySelector("[data-ma-popup-unit]");

        if (labelElement) {
          labelElement.textContent = formatLabel
            ? `${quantity} × ${quantity > 1 ? "POTS" : "POT"} (${formatLabel})`
            : `${quantity} × ${quantity > 1 ? "POTS" : "POT"}`;
        }
        if (totalElement) totalElement.textContent = money(discountedTotal);
        if (savingElement) {
          savingElement.textContent = rate
            ? `Économisez ${money(normalTotal - discountedTotal)}`
            : "À l’unité";
        }
        if (beforeElement) beforeElement.textContent = rate ? money(normalTotal) : "";
        if (unitElement) unitElement.textContent = `${money(unitPrice)} par pot`;
      });

      const total = selectedUnitPrice * selectedQuantity;
      const saving = basePrice * selectedQuantity - total;

      if (grandTotal) grandTotal.textContent = money(total);
      if (globalSaving) globalSaving.textContent = saving ? `Vous économisez ${money(saving)}` : "";

      if (kiloElement) {
        const weightKg = getWeightInKg(variant);
        if (weightKg && weightKg > 0) {
          kiloElement.textContent = `${money(Math.round(selectedUnitPrice / weightKg))}/kg`;
          setHidden(formatHelp, false);
        } else {
          kiloElement.textContent = "";
          setHidden(formatHelp, !coffret);
        }
      }

      addButton.disabled = busy || !variant.available;

      const productWord =
        currentWord ||
        (coffret ? "coffret" : currentKind === "bonbons" ? "sachet" : "pot");

      addButton.innerHTML = busy
        ? "Ajout en cours…"
        : variant.available
          ? `Ajouter ${selectedQuantity} ${plural(productWord, selectedQuantity)} au panier <span aria-hidden="true">↗</span>`
          : "Épuisé";

      if (cardImageUrl) {
        setPopupImage(cardImageUrl);
      } else if (variant.featured_image) {
        setPopupImage(variant.featured_image);
      } else {
        setPopupImage(currentProduct.featured_image || currentProduct.images?.[0]);
      }
    }

    async function openPopup(button) {
      const productUrl = button.dataset.productUrl;
      if (!productUrl) return;

      const cardImage = button.closest(".card")?.querySelector("[data-main-product-image]");
      cardImageUrl = cardImage?.currentSrc || cardImage?.src || button.dataset.productImage || "";

      if (cardImageUrl) {
        setPopupImage(cardImageUrl);
      } else if (image) {
        image.removeAttribute("src");
        image.style.display = "none";
      }

      busy = true;
      if (status) status.textContent = "";
      addButton.disabled = true;
      addButton.textContent = "Chargement…";

      try {
        const productJsonUrl =
          new URL(productUrl, window.location.origin).pathname.replace(/\/$/, "") + ".js";

        const response = await fetch(productJsonUrl, { headers: { Accept: "application/json" } });
        if (!response.ok) throw new Error("Impossible de charger ce produit.");

        currentProduct = await response.json();

        const popupKind = button.dataset.popupKind || "";
        const popupTag = button.dataset.popupTag || "";
        const popupDescription = button.dataset.popupDescription || "";
        const popupTaste = button.dataset.popupTaste || "";
        const popupPairing = button.dataset.popupPairing || "";
        const popupFacts = (button.dataset.popupFacts || "").split("|").map(s => s.trim()).filter(Boolean);
        const popupInfo = button.dataset.popupInfo || "";
        const popupDelivery = button.dataset.popupDelivery || "";

        currentVolumeEligible = button.dataset.volumeEligible === "true";
        currentKind = popupKind;
        currentWord = button.dataset.popupWord || "";
        currentQtyLabel = button.dataset.popupQtyLabel || "";
        currentWeightKg = parseFloat(String(button.dataset.popupWeightKg || "").replace(",", ".")) || 0;

        if (eyebrow) eyebrow.textContent = popupTag || "MESABEILLES · LA BOUTIQUE";
        if (taste) taste.textContent = popupTaste || "";
        if (pairing) pairing.textContent = popupPairing || "";

        const facts = popupFacts.length === 3
          ? popupFacts
          : {
              printemps: ["Doux & floral", "Texture crémeuse", "Origine Normandie"],
              ete: ["Floral & soutenu", "Récolte estivale", "Origine Normandie"],
              foret: ["Boisé & intense", "Notes de forêt", "Origine Normandie"],
              normandie: ["Miel de terroir", "Récolte locale", "Origine Normandie"],
              pollen: ["Récolté par nos soins", "Pollen de châtaignier", "Ruchers de l’Eure"],
              bonbons: ["Fabriqués en France", "2 parfums", "Idée cadeau"]
            }[popupKind] || ["Récolté par nos soins", "Circuit court", "Origine Normandie"];

        if (factOne) factOne.textContent = facts[0];
        if (factTwo) factTwo.textContent = facts[1];
        if (factThree) factThree.textContent = facts[2];

        const info = dialog.querySelector("[data-ma-popup-info]");
        if (info) {
          info.textContent = popupInfo || {
            bonbons: "Conservez vos bonbons dans un endroit sec et frais, sachet bien refermé, à l’abri de la chaleur et de l’humidité.",
            pollen: "Conservez le pollen dans un bocal bien fermé, à l’abri de l’humidité, de la lumière et de la chaleur."
          }[popupKind] || "Conservez le miel dans un endroit sec, à l’abri de la lumière et de la chaleur. Sa cristallisation est naturelle.";
        }

        if (delivery) delivery.textContent = popupDelivery || defaultDelivery;

        if (title) title.textContent = currentProduct.title || button.dataset.productTitle || "";

        if (description) {
          if (popupDescription) {
            description.textContent = popupDescription;
          } else {
            const temporary = document.createElement("div");
            temporary.innerHTML = currentProduct.description || "";
            const cleanDescription = temporary.textContent.replace(/\s+/g, " ").trim();
            description.textContent = cleanDescription.length > 260
              ? cleanDescription.slice(0, 257) + "…"
              : cleanDescription;
          }
        }

        variantSelect.innerHTML = "";
        currentProduct.variants.forEach(variant => {
          const option = document.createElement("option");
          option.value = variant.id;
          option.textContent = variant.title === "Default Title" ? "À l’unité" : variant.title;
          option.disabled = !variant.available;
          variantSelect.appendChild(option);
        });

        const firstAvailable =
          currentProduct.variants.find(variant => variant.available) || currentProduct.variants[0];
        if (!firstAvailable) throw new Error("Aucun format disponible.");

        variantSelect.value = String(firstAvailable.id);
        renderFormatButtons();
        simpleQuantityInput.value = "1";

        const defaultQuantity = currentVolumeEligible ? "3" : "1";
        const defaultQuantityInput = form.querySelector(
          `input[type="radio"][name="quantity"][value="${defaultQuantity}"]`
        );
        if (defaultQuantityInput) defaultQuantityInput.checked = true;

        if (cardImageUrl) {
          setPopupImage(cardImageUrl);
        } else {
          setPopupImage(firstAvailable.featured_image || currentProduct.featured_image || currentProduct.images?.[0]);
        }

        busy = false;
        updatePopup();

        if (typeof dialog.showModal === "function") {
          dialog.showModal();
        } else {
          dialog.setAttribute("open", "");
        }
        dialog.scrollTop = 0;
      } catch (error) {
        busy = false;
        addButton.disabled = false;
        addButton.textContent = "Choisir mon offre";
        if (status) status.textContent = error.message || "Impossible de charger le produit.";
      }
    }

    document.addEventListener("click", event => {
      const button = event.target.closest("[data-ma-open-offer]");
      if (button) {
        event.preventDefault();
        openPopup(button);
      }
    });

    variantSelect.addEventListener("change", () => {
      if (status) status.textContent = "";
      syncFormatButtons();
      updatePopup();
    });

    form.addEventListener("change", event => {
      if (event.target.matches('[name="quantity"]')) {
        if (status) status.textContent = "";
        updatePopup();
      }
    });

    form.addEventListener("submit", async event => {
      event.preventDefault();
      if (!form.reportValidity()) return;

      const variant = getVariant();
      const quantity = getQuantity();
      if (!variant || !variant.available || busy) return;

      busy = true;
      if (status) status.textContent = "";
      updatePopup();

      try {
        const body = new FormData();
        body.append("id", variant.id);
        body.append("quantity", quantity);

        const response = await fetch(shopRoot() + "cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body
        });
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.description || data.message || "Impossible d’ajouter ce produit au panier.");
        }
        window.location.assign(shopRoot() + "cart");
      } catch (error) {
        busy = false;
        if (status) {
          status.textContent = error.message === "Failed to fetch"
            ? "Connexion interrompue. Consultez votre panier avant de réessayer."
            : error.message;
        }
        updatePopup();
      }
    });

    if (closeButton) {
      closeButton.addEventListener("click", () => {
        dialog.close();
      });
    }

    dialog.addEventListener("click", event => {
      if (event.target === dialog) dialog.close();
    });
  }

  function init(scope = document) {
    initProductForms(scope);
    initOfferPopup();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", event => {
    initProductForms(event.target);
    initOfferPopup();
  });
})();
